import { useState } from 'react'
import { FaFileCirclePlus } from 'react-icons/fa6'
import Input from '../../../../shared/components/form/input'
import FormEvent from './FormEvent'
import './formRegisterInfo.css'
import Modal from "../../../../shared/modal/Modal"
/* Function */
import { monthToNominal, monthToNominalShort, monthYear } from "../../Functions/Date"
import FormRecord from './FormRecord'


function FormRegisterEvent({ lastDid, name, description, handleOnSubmit, permission_create }) {

    const [modalNewRecord, setModalNewRecord] = useState(false)
    const [newRecord, setNewRecord] = useState()


    const submit = async (data) => {

        let response = await handleOnSubmit(data)
        if (response === "success") {
            setModalNewRecord(false)

        }


    }

    return (
        <div>
            <div className='form-register-info-box'>
                <span className='form-register-info-title'>Eventos</span>
                <div className='form-register-info-box-box'>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Último Evento</span>
                        <span className='form-register-info-value'>{lastDid ? lastDid : "-------"}</span>
                    </div>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Nome do Evento</span>
                        <span className='form-register-info-value'>{name ? name : "-------"}</span>
                    </div>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Descrição do Evento</span>
                        <span className='form-register-info-value'>{description ? description : "-------"}</span>
                    </div>

                    {permission_create &&
                        <button className='form-register-info-new-btn' onClick={() => { setModalNewRecord(true) }}>
                            <FaFileCirclePlus size={14} /> Novo Registro
                        </button>
                    }
                </div>

            </div>

            <div>






                <Modal
                    modalStatus={modalNewRecord}
                    changeStatus={setModalNewRecord}
                    w={38}
                    h={52}
                    t={20}
                    content={
                        <FormEvent handleOnSubmit={submit} />
                    }
                />



            </div>



        </div>
    )
}

export default FormRegisterEvent